var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header',{attrs:{"table_name":_vm.table_name,"table_type":_vm.table_type,"table_detail":_vm.table_detail}}),_c('Buffet',{attrs:{"typeMenu":_vm.typeMenuBuffet}}),(_vm.open_advertise)?_c('Advertise',{attrs:{"pictureAdvertise":_vm.picture_advertise}}):_vm._e(),_c('Footer',{attrs:{"table_type":_vm.table_type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }